import type { Rarity, Sport } from '#src/__generated__/globalTypes.ts';
import { ANY_SPORT_MY_CARDS_CARDS_TYPE } from '#src/constants/__generated__/routes.ts';
import { useSportContext } from '#src/contexts/sport/index.ts';

export const useGetMyCardsBoostLink = () => {
  const { generateSportContextPath } = useSportContext();

  return ({ rarity, sport }: { rarity: Rarity; sport: Sport }) =>
    `${generateSportContextPath(ANY_SPORT_MY_CARDS_CARDS_TYPE, {
      params: { type: rarity },
      sport,
    })}?selectionMode=boost`;
};
